import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	getCategoryDropdwon,
	getSubCategoryDropdwon,
	getSizeDropdwon,
	getColorDropdown,
	getBrandDropdown,
	getStyleCodeDropdown,
} from '../Redux/features/dropdown/dropdownSlice';

const useFetchDropdowns = () => {
	const dispatch = useDispatch();
	const hasFetched = useRef(false); // Track if we have already attempted fetching

	const {
		categoryDropdown,
		subCategoryDropdown,
		sizeDropdown,
		colorDropdown,
		brandDropdown,
		styleCodeDropdown,
		isLoading,
	} = useSelector((state) => state.dropdown);

	useEffect(() => {
		if (hasFetched.current) return; // Prevent re-fetching

		// Dispatch all actions at once, but only if they haven't been fetched
		dispatch(getCategoryDropdwon());
		dispatch(getSubCategoryDropdwon());
		dispatch(getSizeDropdwon());
		dispatch(getColorDropdown());
		dispatch(getBrandDropdown());
		dispatch(getStyleCodeDropdown());

		hasFetched.current = true; // Mark as fetched
	}, [dispatch]);

	return {
		categoryDropdown,
		subCategoryDropdown,
		sizeDropdown,
		colorDropdown,
		brandDropdown,
		styleCodeDropdown,
		isLoading,
	};
};

export default useFetchDropdowns;
